import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TailSpin as Loading } from 'react-loading-icons';
import style from './loader.scss';

class Loader extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }
  componentDidMount() {
    this.props.fetchData().then((data) => {
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 200);
      return data;
    });
  }

  render() {
    const { children, loading, useGlobalStateLoader = false } = this.props;
    const isLoading = useGlobalStateLoader ? loading : this.state.loading;
    return (
      <div style={{ height: '100%' }}>
        {isLoading ? (
          <div className={style.container}>
            <Loading strokeWidth={3} height="5em" width={60} stroke="#38434B" className="loading-indicator" />
          </div>
        ) : (
          React.cloneElement(children, { key: 1 })
        )}
      </div>
    );
  }
}

Loader.propTypes = {
  children: PropTypes.element.isRequired,
  fetchData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.component.get('loading'),
});

export default connect(mapStateToProps, null)(Loader);
